/** @prettier */
import React from "react";
import classNames from "classnames";
import { ReviewQuestionDataWithImages } from "./testReviewState";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import QuestionReviewInfo from "./QuestionReviewInfo";
import Image from "../View/Image";

const answerLabel = (index: number) =>
    String.fromCharCode("A".charCodeAt(0) + index);

type ReviewQuestionProps = {
    question: ReviewQuestionDataWithImages;
    questionNumber: number;
    totalQuestionCount: number;
};
const ReviewQuestion = ({
    question,
    questionNumber,
    totalQuestionCount,
}: ReviewQuestionProps) => (
    <div className="tr-main-content tr-question">
        <p className="tr-content-heading">
            Question {questionNumber + 1} of {totalQuestionCount}
        </p>
        <p className="tr-question-text">{question.text}</p>
        <div className="tr-question-images">
            {question.images?.state === "loaded" &&
                question.images.stemImages.map(({ id, image, fileName }) => (
                    <Image key={id} name={fileName} image={image} />
                ))}
        </div>
        {question.answerChoices.map((choice, index) => (
            <ReviewAnswerChoice
                key={index}
                state={
                    question.correctAnswer === choice
                        ? "correct"
                        : question.selectedAnswer === index
                        ? "incorrect"
                        : undefined
                }
                selected={question.selectedAnswer === index}
            >
                {`${answerLabel(index)}. ${choice}`}
            </ReviewAnswerChoice>
        ))}
        <QuestionReviewInfo question={question} />
    </div>
);

export default ReviewQuestion;

type ReviewAnswerChoiceProps = {
    state?: "correct" | "incorrect";
    selected: boolean;
    children: string;
};
const ReviewAnswerChoice = ({
    state,
    selected,
    children,
}: ReviewAnswerChoiceProps) => (
    <button
        className={classNames("tr-answer", { selected }, state)}
        disabled={true}
    >
        <div className="tr-answer-badge">
            {state && (
                <FontAwesomeIcon
                    icon={
                        state === "correct"
                            ? ["far", "check-circle"]
                            : ["far", "times-circle"]
                    }
                />
            )}
        </div>
        {children}
    </button>
);
